var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinanceWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33769 10.084L11.9991 5.42491L16.6625 10.0878L19.3732 7.37537L11.9991 0L4.625 7.37348L7.33769 10.084Z",
    fill: "#F3BA2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.9999L2.71182 9.2883L5.42364 11.9999L2.71182 14.7115L0 11.9999Z",
    fill: "#F3BA2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34148 13.9149L12.0029 18.5759L16.6662 13.913L19.3789 16.6216L19.377 16.6235L12.0029 23.9989L4.62879 16.6273L4.625 16.6235L7.34148 13.9149Z",
    fill: "#F3BA2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5781 12.0005L21.2899 9.28891L24.0018 12.0005L21.2899 14.7121L18.5781 12.0005Z",
    fill: "#F3BA2F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.755 11.9985L12.0044 9.24622L9.97035 11.2801L9.73529 11.5132L9.25379 11.9947L9.25 11.9985L9.25379 12.0042L12.0044 14.7526L14.755 12.0004L14.7569 11.9985H14.755Z",
    fill: "#F3BA2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceWalletIcon);
export default __webpack_public_path__ + "static/media/BinanceWalletIcon.c372e3a50b8e48b25d66c84e49a2f694.svg";
export { ForwardRef as ReactComponent };